"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaPartialSelectorResolver = exports.defaultPartialSelectorIgnoredKeys = void 0;
const tslib_1 = require("tslib");
const lodash_clonedeep_1 = tslib_1.__importDefault(require("lodash.clonedeep"));
const PartialSelectorProcessor_1 = require("../../Schema/Processor/PartialSelectorProcessor");
exports.defaultPartialSelectorIgnoredKeys = ["enum", "properties", "title", "description", "default", "items"];
class SchemaPartialSelectorResolver {
    constructor(form, ignoredKeys) {
        this.form = form;
        this.ignoredKeys = [];
        this.ignoredKeys = ignoredKeys ? ignoredKeys : exports.defaultPartialSelectorIgnoredKeys;
        this.resolve();
    }
    resolve() {
        for (const sel of this.form.selectors.values) {
            const prop = sel.property();
            const newDef = PartialSelectorProcessor_1.PartialSelectorProcessor.process((0, lodash_clonedeep_1.default)(prop.def), prop.parentUID, this.ignoredKeys);
            prop.def = Object.assign(Object.assign({}, prop.def), newDef);
        }
    }
}
exports.SchemaPartialSelectorResolver = SchemaPartialSelectorResolver;
